import { useEffect, useState } from 'react';

import { offline } from 'store/errorSlice';

import { useAppDispatch } from './defaultStoreHooks';

const getOnLineStatus = () => navigator?.onLine ?? false;

export const useNavigatorOnLine = () => {
  const [isOnline, setIsOnline] = useState<boolean>(getOnLineStatus());
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.addEventListener('online', () => setIsOnline(true));
    window.addEventListener('offline', () => setIsOnline(false));

    return () => {
      window.removeEventListener('online', () => setIsOnline(true));
      window.removeEventListener('offline', () => setIsOnline(false));
    };
  }, []);

  useEffect(() => {
    if (!isOnline) {
      dispatch(offline());
    }
  }, [dispatch, isOnline]);
};
